import { MouseEvent, useContext } from 'react';
import { TOOLS } from 'constants/tools';
import { useCreateStickerTool } from 'hooks/use-create-sticker-tool';
import { useSelectTool } from 'hooks/use-select-tool';
import { ToolbarContext } from 'context/toolbar-context/toolbar-context';
import { useCreateCardTool } from 'hooks/use-create-card-tool';
import { useHandTool } from 'hooks/use-hand-tool';
import { CanvasContext } from 'context/canvas-context/canvas-context';
import { getTransformedPoint } from 'utils/geometry';

export function useCanvasOnClick() {
	const { tool } = useContext(ToolbarContext);
	const { renderer } = useContext(CanvasContext);
	const createSticker = useCreateStickerTool();
	const createCard = useCreateCardTool();
	const selectTool = useSelectTool();
	const handTool = useHandTool();

	return function (event: MouseEvent) {
		event.preventDefault();

		if (renderer) {
			const currentTransformedPosition = getTransformedPoint(
				event.pageX,
				event.pageY,
				renderer.getTransform()
			);
			const pageX = currentTransformedPosition.x;
			const pageY = currentTransformedPosition.y;

			if (tool === TOOLS.STICKER) {
				createSticker({ pageX, pageY });
			}

			if (tool === TOOLS.CARD) {
				createCard({ pageX, pageY });
			}

			if (tool === TOOLS.SELECT) {
				selectTool({ pageX, pageY });
			}

			if (tool === TOOLS.HAND) {
				handTool({ pageX, pageY });
			}

			if (tool === TOOLS.DEV) {
				// only for dev purpose
			}
		}
	};
}
